import { useAuthStore } from '@/features/auth/useAuthStore.js'
import { setActiveClubId } from '@/features/router/useActiveClub.js'
import { useClubRouter } from '@/features/router/useClubRouer.js'

export function clubIdSetterGuard(to, from, next) {
  const clubId = to?.query?.clubId || to?.query?.clubid
  const systemAuthToken = to?.query?.systemAuthToken
  const router = useClubRouter()

  const authStore = useAuthStore()
  if (systemAuthToken) {
    console.log('[clubIdSetterGuard] Setting systemAuthToken', systemAuthToken)
    authStore.setUserToken(systemAuthToken)

    const newQuery = { ...to.query }
    delete newQuery.systemAuthToken

    console.log('[clubIdSetterGuard] systemAuthToken removed from query', newQuery)
    console.log('[clubIdSetterGuard] Redirecting to', { ...to, query: newQuery })

    router.replace({
      ...to,
      query: newQuery,
    })
  }

  if (clubId) {
    console.log('[clubIdSetterGuard] Setting clubId', clubId)

    // Only set the club ID if it's different from current activeClubId to prevent loops
    const currentActiveClubId = to.query.activeClubId
    if (currentActiveClubId !== clubId) {
      setActiveClubId(clubId)

      const newQuery = { ...to.query, activeClubId: clubId }
      router.replace({
        ...to,
        query: newQuery,
      })
    }
  }

  next()
}
